<template lang="pug">
  include ../../Bemto
  div
    slot(
      name='btn',
      :open='() => showSidebar()',
      :is-open='show'
    )
    transition(name='fade')
      .is-blured(
        v-if='show'
        @click.prevent='showSidebar()'
      )
    transition(name='fadeInDown')
      +b#side-menu.side-menu(
        v-if='show'
        :class="{'side-menu__talent': isTalentCareer}"
      )
        slot(
          :close='() => show = false'
          name='sidebar'
        )
</template>

<script>
export default {
  name: "MenuTrigger",
  data() {
    return {
      show: false,
      role: window.ROLE,
    }
  },
  created() {
    this.path = window.location.pathname || ""
  },
  computed: {
    isTalentCareer() {
      const p = this.path.replace(/\/+$/, "")
      return /(^|\/)talent-career$/.test(p)
    },
  },
  methods: {
    showSidebar() {
      this.show = !this.show
      this.$body.dataset.blocked = this.show
    },
  },
}
</script>
